export function findFromBrands(name, providedArray) {
  return providedArray?.find(channel => {
    if (channel.name === name) return true;
    if (channel.brands) return findFromBrands(name, channel.brands);
    return false;
  });
}
export function parseUrlParams(searchString) {
  const params = {};
  if (!searchString || searchString.length === 0) {
    return params;
  }

  // Remove the leading '?' if present
  const queryString = searchString.charAt(0) === "?" ? searchString.slice(1) : searchString;

  // Split by '&' and process each parameter
  const pairs = queryString.split("&");
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i];
    const equalIndex = pair.indexOf("=");

    if (equalIndex !== -1) {
      const key = decodeURIComponent(pair.substring(0, equalIndex));
      const value = decodeURIComponent(pair.substring(equalIndex + 1));
      params[key] = value;
    }
  }

  return params;
}
